<script setup>
import {computed, inject, ref, watch} from 'vue';
import SubmitButtonLargeComponent from '@buttons/SubmitButtonLargeComponent.vue';
import {debounce} from 'lodash';
import {showErrorToast, showSuccessToast} from '@utils/Toast';
import ButtonComponent from '@buttons/ButtonComponent.vue';
import MainProgressBarComponent from '../../Helper/MainProgressBarComponent.vue';
import {handleErrorResponse} from '@utils/errorHandler';

const props = defineProps({
    csrf: String,
    route: String,
    routeSuccess: String,
    user: Object,
});

// Inject Axios
const axios = inject('axios');

const title = props.user.first_name + ', thank you for completing your EVED Portal onboarding process.<br />' +
    'Click below to explore all our course offerings!';

const uploadPercentage = computed(() => (6/6) * 100 );

const isFormValid = ref(true);

const delayedRedirection = debounce(() => {
    window.location.href = props.routeSuccess;
}, 2000);


const submitForm = async () => {
    if(isFormValid.value) {
        //Prepare the data to be sent
        const formData = null;

        try {
            //Send a POST request to the server
            const response = await axios.post(props.route, formData, {
                headers: {
                    'X-CSRF-TOKEN': props.csrf // Include CSRF token here
                }
            });
            //Handle response here
            if(response.status === 200) {
                const data = response.data;
                if(data.success === 1) {
                    showSuccessToast(data.message);
                    delayedRedirection();
                } else {
                    showErrorToast(data.message);
                }
            } else {
                if(response.message) {
                    showErrorToast(response.message);
                }
            }

        } catch (error) {
            showErrorToast(handleErrorResponse(error));
            console.error('Submission error', error);
        }
    }
};

</script>

<template>
    <div class="container sm:max-w-6xl text-center py-6">
        <main-progress-bar-component :upload-percentage="uploadPercentage"></main-progress-bar-component>
        <div class="font-bold text-xl md:text-2xl pb-6 pt-12 md:pt-20 leading-tight" v-html="title"></div>

        <form :action="route" id="frmClientLogin" method="post"
              @submit.prevent="submitForm"
        >

            <div class="flex items-center justify-center gap-4 container max-w-100 md:w-100">
                <SubmitButtonLargeComponent
                    title="Continue to EVED"
                    btn-class="btn-green-5 w-full !py-4"
                >
                </SubmitButtonLargeComponent>
            </div>
        </form>
    </div>
</template>

<style scoped lang="scss">
.form {
    &-row {
        @apply mb-6;
    }
    &-control {
        @apply bg-white py-3;
    }
}
</style>
